<template>
  <time class="basic-date" :datetime="date" v-text="title" />
</template>

<script>
  export default {
    name: 'BasicDate',
    props: {
      date: {
        type: [String, Number],
        required: true,
      },
      title: {
        type: String,
        required: true,
      }
    }
  }
</script>